// extracted by mini-css-extract-plugin
module.exports = {"footer":"styles_footer__3KCL9","content":"styles_content__3ZpUN","checkbox":"styles_checkbox__34dcQ","checkboxLabel":"styles_checkboxLabel__3YRIQ"};